<template>
	<AuthLayout title="Register">
		<div class="list-group-item p-4">
			<form @submit.prevent="register">
				<div class="form-group">
					<input
						class="form-control"
						placeholder="name"
						required
						type="text"
						v-model="name"
					>
				</div>
				<div class="form-group">
					<input
						class="form-control"
						placeholder="email"
						required
						type="email"
						v-model="email"
					>
				</div>
				<div class="form-group">
					<input
						class="form-control"
						placeholder="password"
						required
						type="password"
						v-model="password"
					>
				</div>
				<div class="form-group">
					<input
						class="form-control"
						placeholder="password again"
						required
						type="password"
						v-model="password2"
					>
				</div>
				<div class="d-flex justify-content-between mt-5">
					<router-link
						class="btn btn-outline-primary"
						to="/login"
					>&laquo; Log in</router-link>
					<button
						class="btn btn-primary"
						type="submit"
					>Register</button>
				</div>
				<vue-recaptcha
					ref="captcha"
					size="invisible"
					@verify="onVerify"
					@expired="onExpired"
					:sitekey="sitekey"
					:loadRecaptchaScript="true"
				>
				</vue-recaptcha>
			</form>
		</div>
	</AuthLayout>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import AuthLayout from '@/layouts/AuthLayout.vue'
import auth from '@/auth'

export default {
	components: { AuthLayout, VueRecaptcha },
	data() {
		return {
			name: null,
			email: null,
			password: null,
			password2: null,
			sitekey: '6LeD1wgaAAAAACCduzu9_-PWjPaCSp-9XkBCoVYn', // TODO env?
		}
	},
	methods: {
		register() {
			auth.resetAuthMessages()
			const { password, password2 } = this
			if (password !== password2) {
				this.sharedState.authError = 'Please repeat the same password!'
			} else {
				this.sharedState.loading = true
				this.$refs.captcha.execute()
				// rest will happen in onVerify()
			}
		},
		async onVerify(response) {
			const { name, email, password } = this
			try {
				await auth.submitRegisterForm(name, email, password, response)
				this.name = null
				this.email = null
				this.password = null
				this.password2 = null
				this.sharedState.authSuccess =
					'An email has been sent to you with instructions on how to verify your account.'
				this.$router.push('/login')
			} catch (error) {
				this.sharedState.authError = error
			} finally {
				this.sharedState.loading = false
			}
		},
		onExpired() {
			this.$refs.captcha.reset()
		},
	},
	beforeRouteEnter(to, from, next) {
		auth.resetAuthMessages()
		next()
	},
	beforeRoutUpdate(to, from, next) {
		this.$refs.captcha.reset()
		next()
	},
}
</script>
